const campaignStatusCanonical = Object.freeze({
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  LIVE: 'live',
  PAST: 'past'
})

export { campaignStatusCanonical }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignStatusCanonicalEnum.js